import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { MasterDataService } from "../../service/master-data.service";
import { DxListComponent } from 'devextreme-angular';
import { City, Country, CustomerSite, StateProvince } from "../../model/shared.model";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";

@Component({
    selector: 'customer-site',
    templateUrl: './customer-site.component.html',
    styleUrls: ['./customer-site.component.scss']
})

export class CustomerSiteComponent implements OnChanges {
    @ViewChild(DxListComponent, { static: false }) dataList: DxListComponent;
    @Input() buttonTrigger: boolean;
    @Output() setLoadPanelVisibility: EventEmitter<boolean> = new EventEmitter();
    @Output() setPopupVisibility: EventEmitter<boolean> = new EventEmitter();
    @Output() setSiteId: EventEmitter<number> = new EventEmitter();
    @Output() setCustomer: EventEmitter<string> = new EventEmitter();
    title: string;
    popupVisible: boolean;
    isLoadPanelVisible: boolean = false;
    filteredCustomerSiteList: CustomerSite[];
    customerSiteList: CustomerSite[];
    siteInfoResponseReceived: boolean;
    countryResponseReceived: boolean;
    stateResponseReceived: boolean;
    cityResponseReceived: boolean;
    public frmCustomerSite: CustomerSite;
    countries: Country[];
    states: StateProvince[];
    cities: City[];
    citiesDataSource: DataSource;
    filteredCountries: string[];
    filteredStates: string[];
    filteredCities: string[];
    siteName: string;
    country: string;
    state: string;
    city: string;

    constructor(private masterDataService: MasterDataService, private notificationService: NotificationService) {
        this.title = 'Choose Site'
        this.popupVisible = false;
        this.countries = [];
        this.filteredStates = [];
        this.cities = [];
        this.frmCustomerSite = new CustomerSite();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['buttonTrigger'] && changes['buttonTrigger']?.previousValue != changes['buttonTrigger']?.currentValue) {
            this.popupVisible = changes['buttonTrigger']?.currentValue;
            if (this.popupVisible) this.openPopup();
        }
    }

    getSites() {
        try {
            this.masterDataService.getCustomerSites().subscribe(data => {
                if (data) {
                    this.customerSiteList = data;
                    this.siteInfoResponseReceived = true;
                    if (this.hasPopupServiceResponseReceived()) this.isLoadPanelVisible = false;
                }
            },
                error => {
                    this.notificationService.alert("error", "Error occured while fetching the Price Uoms", error);
                    this.isLoadPanelVisible = false;
                });
        }
        catch (e) {
            this.notificationService.alert("error", "Error occured while fetching the Price Uoms", null);
            this.isLoadPanelVisible = false;
        }
    }

    getCountries() {
        try {
            this.masterDataService.getCountries().subscribe(data => {
                if (data) {
                    this.countryResponseReceived = true;
                    this.countries = data;
                    this.filteredCountries = [...new Set(this.countries.map(item => item.countryName))];
                    this.filteredCountries.sort();
                    if (this.hasPopupServiceResponseReceived()) this.isLoadPanelVisible = false;
                }
            },
                error => {
                    this.notificationService.alert("error", "Error occured while fetching the countries", error);
                    this.isLoadPanelVisible = false;
                });
        }
        catch (e) {
            this.notificationService.alert("error", "Error occured while fetching the countries", null);
            this.isLoadPanelVisible = false;
        }
    }

    getStates() {
        try {
            this.masterDataService.getProvinces().subscribe(data => {
                if (data) {
                    this.stateResponseReceived = true;
                    this.states = data;
                    if (this.hasPopupServiceResponseReceived()) this.isLoadPanelVisible = false;
                }
            },
                error => {
                    this.notificationService.alert("error", "Error occured while fetching the states", error);
                    this.isLoadPanelVisible = false;;
                });
        }
        catch (e) {
            this.notificationService.alert("error", "Error occured while fetching the states", null);
            this.isLoadPanelVisible = false;
        }
    }

    getCities(provinceId:number) {
        try {
            this.masterDataService.getCities(provinceId).subscribe(data => {
                if (data) {
                    this.cityResponseReceived = true;
                    this.cities = data;
                    this.filteredCities = [...new Set(this.cities.map(item => item.city))];
                    this.filteredCities.sort();
                    this.citiesDataSource = new DataSource({
                        store: new ArrayStore({
                            data: this.filteredCities,
                            key: '',
                        })
                    });
                    this.filterItems();
                    if (this.hasPopupServiceResponseReceived()) this.isLoadPanelVisible = false;
                }
            },
                error => {
                    this.notificationService.alert("error", "Error occured while fetching the materials", error);
                    this.isLoadPanelVisible = false;
                });
        }
        catch (e) {
            this.notificationService.alert("error", "Error occured while fetching the materials", null);
            this.isLoadPanelVisible = false;
        }
    }

    openPopup() {
        this.popupVisible = true;
        this.filteredCustomerSiteList = undefined;
        if (this.customerSiteList !== undefined) {
            return;
        }
        this.isLoadPanelVisible = true;
        this.getCountries();
        this.getSites();
        this.getStates();
    }

    closePopup() {
        this.clearFields();
        this.filteredCustomerSiteList = undefined;
        this.popupVisible = false;
        this.setPopupVisibility.emit(false);
    }

    clearFields() {
        this.siteName = null;
        this.country = null;
        this.state = null;
        this.city = null;
    }

    hasPopupServiceResponseReceived(): boolean {
        return this.siteInfoResponseReceived && this.countryResponseReceived && this.stateResponseReceived;
    }

    onCountryValueChanged(e) {
        this.filteredStates = [];
        this.filteredCities = [];
        this.citiesDataSource = null;
        this.state = null;
        this.city = null;
        if (e.value == null) {
            this.filterItems();
            return;
        }
        var filteredList = this.states.filter(n => n.country == e.value);
        this.filteredStates = [...new Set(filteredList.map(item => item.province))];
        this.filteredStates.sort();
        this.filterItems();
    }

    onStateValueChanged(e) {
        this.filteredCities = [];
        this.citiesDataSource = null;
        this.city = null;
        if (e.value == null) {
            this.filterItems();
            return;
        }
        var selectedState = this.states.filter(s => s.province == e.value);
        this.getCities(selectedState[0].statProvId);
    }

    onCityValueChanged(e) {
        this.filterItems();
    }

    siteValueChanged(e) {
        this.filterItems();
    }

    filterItems(): void {
        this.filteredCustomerSiteList = this.customerSiteList.filter(item =>
            (this.siteName == undefined || (item.customer != null && item.customer.toLowerCase().indexOf(this.siteName.toLowerCase()) !== -1))
            && ((this.country == undefined || this.country == null) || (item.country != null && item.country.toLowerCase().indexOf(this.country.toLowerCase()) !== -1))
            && ((this.state == undefined || this.state == null) || (item.state != null && item.state.toLowerCase().indexOf(this.state.toLowerCase()) !== -1))
            && ((this.city == undefined || this.city == null) || (item.city != null && item.city.toLowerCase().indexOf(this.city.toLowerCase()) !== -1))
        );
        this.filteredCustomerSiteList.sort((a, b) => {
            return a.customer.localeCompare(b.customer);
        });
    }

    selectSite() {
        if (!this.dataList.selectedItems) return;
        this.setSiteId.emit(this.dataList.selectedItems[0].siteId);
        this.setCustomer.emit(this.dataList.selectedItems[0].customer);
        this.clearFields();
        this.popupVisible = false;
        this.setPopupVisibility.emit(false);
    }
}